export enum CmmDocType {
  CMM_SCREENSHOT = "cmm_screenshot",
  PRESCRIPTION = "prescription",
  INUSRANCE_CARD = "insurance_card",
  CLINICAL_ATTACHMENT = "clinical_attachment",
  DENIAL_LETTER = "denial_letter",
  APPROVAL_LETTER = "approval_letter",
}
